import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const AccountsModelSchema = z
  .object({
    id: z.string(),
    name: z.string().nullish(),
    legal_name: z.string().nullish(),
    aliases: z.array(z.string()).nullish(),
    account_number: z.string().nullish(),
    priority: z.string().nullish(),
    track: z.boolean().nullish(),
    description: z.string().nullish(),
    // The {{team_name}} greeting for team-mode email dispatch (falls back to name when blank).
    team_name: z.string().nullish(),
    notes: z.string().nullish(),
    website: z.string().nullish(),
    domain: z.string().nullish(),
    industry: z.string().nullish(),
    critical_technology_area: z.string().nullish(),
    investor_classification_id: z.number().nullish(),
    share_register_id: z.string().nullish(),
    incorporation: z.string().nullish(),
    founded_in_country_code: z.string().nullish(),
    founded_in_city_code: z.number().nullish(),
    founded_in_city_label: z.string().nullish(),
    founded_in_stateprovince: z.string().nullish(),
    business_city_code: z.number().nullish(),
    business_city_label: z.string().nullish(),
    business_country_code: z.string().nullish(),
    business_country_label: z.string().nullish(),
    business_address_1: z.string().nullish(),
    business_address_2: z.string().nullish(),
    business_stateprovince: z.string().nullish(),
    business_postalcode: z.string().nullish(),
    office_city_code: z.number().nullish(),
    office_country_code: z.string().nullish(),
    office_address_1: z.string().nullish(),
    office_address_2: z.string().nullish(),
    office_stateprovince: z.string().nullish(),
    office_postalcode: z.string().nullish(),
    same_as_business_address: z.boolean().nullish()
  })
  .strict()

export const AccountsModelFields = makeFieldKeys(AccountsModelSchema)

export type AccountsModel = z.infer<typeof AccountsModelSchema>

function validateAccountsModel(data: unknown): AccountsModel {
  try {
    return validateWithZodSchema(AccountsModelSchema, data, 'accounts model')
  } catch (error) {
    throw new Error(`Accounts model validation failed: ${error}`)
  }
}
